import { MouseEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RouterUrl } from "../../common/Params";
import configcss from "../../css/config.module.css";

export type CompleteParam = {
    message: string,
}

export const ResultMessage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = location.state as CompleteParam;

    function ToConfig(e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) {
        navigate(RouterUrl.Upload, {});
    }

    return (
        
            <div className={configcss['resultMessageContents']}>
                <div className={configcss['resultMessage']}>{params.message}</div>
                <button className={configcss['resultBtn']} onClick={ToConfig}>OK</button>
            </div>
        
    )
}

export const ResultMessageFromProp = (prop: CompleteParam) => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = location.state as CompleteParam;

    function ToConfig(e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) {
        navigate(RouterUrl.Upload, {});
    }

    return (
        
            <div className={configcss['resultMessageContents']}>
                <div className={configcss['resultMessage']}>{prop.message}</div>
                <button className={configcss['resultBtn']} onClick={ToConfig}>OK</button>
            </div>
        
    )
}